// extracted by mini-css-extract-plugin
export default {"main":"style_main__Wv5t5","subTitle":"style_subTitle__4gBDH","examList":"style_examList__B+dfF","examBlock":"style_examBlock__tD-ua","tipBtn":"style_tipBtn__kiPnF"};